import { useEffect, useState } from 'react';
import BrandMark from './BrandMark';

export default function Loader({ onDone }) {
  const [p, setP] = useState(0);
  const [gone, setGone] = useState(false);

  useEffect(() => {
    let v = 0;
    const id = setInterval(() => {
      v += Math.max(5, Math.round((100 - v) * 0.22));
      if (v >= 100) {
        v = 100;
        clearInterval(id);
        setTimeout(() => { setGone(true); onDone && onDone(); }, 350);
      }
      setP(v);
    }, 40);
    return () => clearInterval(id);
  }, [onDone]);

  return (
    <div
      data-testid="site-loader"
      className="fixed inset-0 z-[10000] flex items-center justify-center bg-white transition-opacity duration-700"
      style={{ opacity: gone ? 0 : 1, pointerEvents: gone ? 'none' : 'auto' }}
    >
      <div className="absolute inset-0 grain pointer-events-none" />
      <div className="absolute -top-40 -left-40 h-[460px] w-[460px] hero-gradient-orb" />
      <div className="relative flex flex-col items-center gap-8">
        <div className="scale-125"><BrandMark size="xl" /></div>
        <div className="flex items-baseline gap-4 font-display">
          <span className="text-5xl font-light tabular-nums text-ink-900">{String(p).padStart(3, '0')}</span>
          <span className="text-sm uppercase tracking-[0.3em] text-ink-400">Loading</span>
        </div>
        <div className="h-px w-[260px] overflow-hidden bg-ink-100">
          <div className="h-full bg-cyan-gradient transition-[width] duration-200" style={{ width: `${p}%` }} />
        </div>
      </div>
    </div>
  );
}
